export const obterSenhaSyncAtual = (): string => {
    const date = new Date();
    return `@${date.getDate() + (date.getMonth() + 1)}${(date.getHours() + 10)}`
}